// extracted by mini-css-extract-plugin
module.exports = {"list":"subcategory_list__Mo4Ep"};